import { getResourceDownloadToken } from "../../data/dataCIMToolkit";
import revertTitle from "./revertTitle";

const openResource = async (id, token) => {
  const resourceDownloadTokenResponse = await getResourceDownloadToken(id, token);

  if (resourceDownloadTokenResponse.data.resourceData.type === 'application/urb') {
    const instruction = 'open'
      + '|' + resourceDownloadTokenResponse.data.resourceData.id
      + '|' + resourceDownloadTokenResponse.data.resourceData.name
      + '|' + resourceDownloadTokenResponse.data.url;

    document.title = instruction;
    revertTitle();
  }

};

export default openResource;
